import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { CookieService } from 'ngx-cookie-service';

import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { SimpleNotificationsModule } from 'angular2-notifications';
import { AuthInterceptor } from './services/authinterceptor';
import { AccountService } from './services/account.service';
import { AuthGuard, InitGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { ClientService } from './services/client.service';
import { LoginService } from './services/login.service';
import { MessageService } from './services/message.service';
import { ClientStyleService } from './services/client-style.service';
import { LookupTypeService } from './services/lookup-type.service';

import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { BaseComponent } from './pages/base/base.component';
import { MainPipe } from './pipes/main-pipe.module';
import { PaymentOptionsModal } from './modals/payment-options.modal';
import { HeartlandFormComponent } from './pages/clearing/heartland-form.component';
import { MonerisCheckoutFormComponent } from './pages/clearing/moneris-checkout-form.component';
import { CyberSourceFormComponent } from './pages/clearing/cyber-source-form.component';

@NgModule({
	declarations: [
		AppComponent,
		BaseComponent,
		routingComponents,
		PaymentOptionsModal,
		HeartlandFormComponent,
		MonerisCheckoutFormComponent,
		CyberSourceFormComponent    
		],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		FormsModule,
		MainPipe,
		MatCardModule,
		MatIconModule,
		MatInputModule,
		MatButtonModule,
		MatFormFieldModule,
		MatSlideToggleModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatGridListModule,
		MatCheckboxModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatDialogModule,
		MatTableModule,
		MatToolbarModule,
		MatPaginatorModule,
		HttpClientModule,
		ReactiveFormsModule,
		SimpleNotificationsModule.forRoot()
		],
	providers: [
		AccountService,
		AuthGuard,
		InitGuard,
		AuthService,
		CookieService,
		ClientService,
		LoginService,
		MessageService,
		ClientStyleService,
		LookupTypeService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		}
		],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	bootstrap: [AppComponent]
})
export class AppModule { }
